import React from 'react';

export default function InputValidationErrorMessage(props) {
    const errors = props.validation_errors || [];
    const fieldError = errors.find((error) => error.error_field === props.error_field);
    
    // Check if error exists
    if (fieldError) {
        const isRequiredError = fieldError.error.toLowerCase().includes("required");
        if (!isRequiredError || !props.input_field || props.input_field === "") {
            return (
                <p className="invalid-feedback text-left mt-0 d-block">
                    {fieldError.error}
                </p>
            );
        }
    }
    return null;
}